import { CircularProgress } from '@mui/material'
import { useContext, useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getDataWithParams } from 'src/consumer/services/profileService'
import { getImageLink, isCommonResponseSuccessful } from 'src/mentor/helpers/utilityFunctions'
import Star_Image from 'src/assets/unlimited_star.png'
import { InformationContext } from '../../context/InformationContext'
import { SetupContext } from '../../context/SetupContext'
import { getGenericCardDetails } from '../../helpers/genericCardHelper'
import { StyledCardInfoSeparator } from '../BrowserByCategory/BrowserByCategoryStyle'
import { HorizontalScrollLeftButton, HorizontalScrollRightButton } from '../CardList/CardListStyle'
import { IconImage } from 'src/shared/styled/sharedPrimitives'
import { AppExclusiveText, GenericCardCategory } from '../GenericCards/GenericCardStyle'
import {
  ActivityPlanAppExclusiveContainer,
  ActivityPlanCardBackground,
  ActivityPlanCardNavigatingContainer,
  ActivityPlanCardsContainer,
  ActivityPlanContainer,
  ActivityPlanTitle,
} from './ActivityPlanCardStyles'

const renderCardsList = (props, setupData, setInformationModalData) => {
  return props.cardsData?.map((item, index) => (
    <ActivitySinglePlan key={index} {...props} item={item} setupData={setupData} />
  ))
}

export default function ActivityPlanCard({ areTileItemsHovered, ...props }) {
  const { informationModalData, setInformationModalData } = useContext(InformationContext)
  const { setupData } = useContext(SetupContext)
  const cardRef = useRef()
  const [leftButtonVisible, setLeftButtonVisible] = useState(false)
  const [rightButtonVisible, setRightButtonVisible] = useState(false)
  const handleScrollLeft = () => {
    if (cardRef?.current) {
      const containerWidth = cardRef?.current?.offsetWidth
      const scrollDistance = containerWidth * 0.75
      cardRef.current.scrollLeft -= scrollDistance // adjust the scroll distance as needed
    }
  }
  const handleScrollRight = () => {
    if (cardRef?.current) {
      const containerWidth = cardRef?.current?.offsetWidth
      const scrollDistance = containerWidth * 0.75
      cardRef.current.scrollLeft += scrollDistance // adjust the scroll distance as needed
    }
  }
  const handleScroll = (event) => {
    const container = event?.target
    const scrollPosition = container?.scrollLeft
    const maxScrollLeft = container?.scrollWidth - container?.clientWidth
    const reachedLeftEnd = scrollPosition === 0
    const reachedRightEnd = scrollPosition === maxScrollLeft
    setLeftButtonVisible(!reachedLeftEnd)
    setRightButtonVisible(!reachedRightEnd)
  }

  useEffect(() => {
    const container = cardRef?.current
    const scrollPosition = container?.scrollLeft
    const maxScrollLeft = container?.scrollWidth - container?.clientWidth
    const reachedLeftEnd = scrollPosition === 0
    const reachedRightEnd = scrollPosition === maxScrollLeft
    setLeftButtonVisible(!reachedLeftEnd)
    setRightButtonVisible(!reachedRightEnd)
  }, [])

  return (
    <ActivityPlanCardsContainer ref={cardRef} onScroll={handleScroll}>
      {areTileItemsHovered && leftButtonVisible && (
        <HorizontalScrollLeftButton onClickFunction={handleScrollLeft} />
      )}
      {renderCardsList({ ...props }, setupData, setInformationModalData)}
      {areTileItemsHovered && rightButtonVisible && (
        <HorizontalScrollRightButton onClickFunction={handleScrollRight} />
      )}
    </ActivityPlanCardsContainer>
  )
}

function ActivitySinglePlan({ item, setupData, cardsType, cardsCategory }) {
  const { imgId, category, title } = getGenericCardDetails(
    item,
    setupData,
    cardsType,
    cardsCategory,
    'activityPlan',
  )
  const navigate = useNavigate()
  const [navigating, setNavigating] = useState(false)

  function navigateToActivityPlanPurchasePage(activityPlan) {
    navigate(`/plan/${activityPlan?.slug}`)
  }
  function navigateToMyActivityPlanPage(activityPlan) {
    navigate(`/my-activity/${activityPlan?.id}`)
  }

  async function handleClick() {
    if (!navigating) {
      setNavigating(true)
      const resp = await getDataWithParams(`/api/secure/v3/activity-plan`, {
        planId: item?.activityPlan?.id,
      })
      if (resp.status === 200 && isCommonResponseSuccessful(resp?.data?.code)) {
        navigateToMyActivityPlanPage(item?.activityPlan)
      } else {
        navigateToActivityPlanPurchasePage(item?.activityPlan)
      }
      setNavigating(false)
    }
  }

  return (
    <ActivityPlanContainer onClick={handleClick}>
      <ActivityPlanCardBackground src={getImageLink(imgId)} />
      <ActivityPlanCardNavigatingContainer navigating={navigating}>
        <CircularProgress sx={{ color: '#ebebeb' }} />
      </ActivityPlanCardNavigatingContainer>
      <ActivityPlanAppExclusiveContainer>
        {category && <GenericCardCategory>{category}</GenericCardCategory>}
        {category && <StyledCardInfoSeparator />}
        <ActivityPlanTitle>{title}</ActivityPlanTitle>
        <AppExclusiveText>
          App Exclusive
          <IconImage src={Star_Image} w={20} h={20} />
        </AppExclusiveText>
      </ActivityPlanAppExclusiveContainer>
    </ActivityPlanContainer>
  )
}
